import { jsx as m, jsxs as o } from "react/jsx-runtime";
import * as l from "react";
import { c as i } from "../clsx-OuTLNxxd.js";
import '../Stats.css';const I = "_stats_5xgse_32", n = "_statsItem_5xgse_41", _ = "_statsItemTitle_5xgse_60", f = "_statsItemValue_5xgse_73", s = {
  stats: I,
  statsItem: n,
  statsItemTitle: _,
  statsItemValue: f
}, x = l.forwardRef(({ className: t, ...a }, e) => /* @__PURE__ */ m("div", { className: i(s.stats, t), "data-cxy-name": "stats", ref: e, ...a })), p = l.forwardRef(({ "aria-label": t, className: a, title: e, value: c, ...r }, d) => /* @__PURE__ */ o(
  "div",
  {
    className: i(s.statsItem, a),
    ref: d,
    ...r,
    "aria-label": t,
    "data-testid": "stats-item",
    children: [
      /* @__PURE__ */ m("p", { "aria-hidden": !!t, className: s.statsItemValue, children: c }),
      /* @__PURE__ */ m("p", { "aria-hidden": !!t, className: s.statsItemTitle, children: e })
    ]
  }
));
x.displayName = "Stats";
p.displayName = "StatsItem";
export {
  x as Stats,
  p as StatsItem
};
